module.exports = __webpack_public_path__ + "static/img/RAPD-1U460-B_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPD-1U460-B_1.png
// module id = P0NH
// module chunks = 0